import { Box, CircularProgress, Skeleton, useTheme } from "@mui/material";
import theme from "theme/ThemeContext";
import vegIcon from "assests/Group 78.svg"
import nonvegIcon from "assests/Group 92.svg"
import eggIcon from "assests/Group 93.svg"

export const sidebarItems = [
  { text: "Dashboard", icon: "fa-solid fa-house", route: "/dashboard" },
  { text: "Analytics", icon: "fa-solid fa-chart-line", route: "/analytics" },
]
export const MESSAGES = {
  NO_MENU_ITEMS: "No menu items found.",
  // …add more messages here as you go
};
export const pageConfig = {
  "user-list": {
    // addPath: "/add-user",
    // editPath: (id) => `/user-listing/update-user`,
    // viewPath: (id) => `/user-listing/view-user`,
    addPath: "/users",
    editPath: (id) => `/users`,
    viewPath: (id) => `/users`,
  },
};



export const CenteredLoader = () => {
  return (
    <Box className='center-loader'>
      <CircularProgress sx={{ color: theme.palette.primary.main }} />
    </Box>
  );
};

export const typeIcons = {
  veg: vegIcon,
  "non-veg": nonvegIcon,
  eggetarian: eggIcon,
  vegan: vegIcon,
}

export const orderSummary = [
  {
    id: "1",
    title: "Total Orders",
    subtitle: "(Today)",
    value: "15",
    highlight: true,
  },
  {
    id: "2",
    title: "Takeaway Orders",
    value: "15",
    highlight: true,
  },
  {
    id: "3",
    title: "Delivery Orders",
    value: "15",
    highlight: true,
  },
  {
    id: "4",
    title: "Available Tables",
    value: "9/15",
    highlight: true,
  },
]


export const defaultTableOptions = [
  { value: "D1", label: "Dummy Table 1" },
  { value: "D2", label: "Dummy Table 2" },
  { value: "D3", label: "Dummy Table 3" },
];

export const manageAccountRoles = [
  { value: 'pos', label: "POS" },
  { value: 'chef', label: "Chef" },
  { value: 'emenu', label: "E-Menu" },
  { value: 'rider', label: "Rider" },
]


export const TableSkeleton = () => {
  const theme = useTheme()
  // Adjust the number of rows and dimensions as needed.
  const rows = [1, 2, 3, 4, 5, 6, 7]

  return (
    <Box sx={{ width: "100%" }}>
      {rows?.map((row) => (
        <Skeleton
          key={row}
          variant="rectangular"
          width="100%"
          height={40}
          sx={{
            mb: 1,
            backgroundColor: theme.palette.action.hover, // you can customize the skeleton color here
          }}
        />
      ))}
    </Box>
  )
}

export const foodItemType = [
  {
    id: 1,
    name: 'Veg',
    value: 'veg'
  },
  {
    id: 2,
    name: 'Non-veg',
    value: 'non-veg'
  },
  {
    id: 3,
    name: 'Eggetarian',
    value: 'eggetarian'
  },
  {
    id: 4,
    name: 'Vegan',
    value: 'vegan'
  },
]

export const ordersFilterConfigs = [
  { id: 'All', label: 'All', color: '#000000', backgroundColor: '#000000' },
  { id: 'pos', label: 'Takeaway', color: '#E86400', backgroundColor: '#E86400' },
  { id: "collection_point", label: 'Collection Point', color: "#9c9311", backgroundColor: "#9c9311" },
  { id: 'dine_in', label: 'Dine-In', color: '#1361D5', backgroundColor: '#1361D5' },
  { id: 'delivery', label: 'Delivery', color: '#04ADB3', backgroundColor: '#04ADB3' },
  { id: 'phone_order', label: 'Phone Order', color: '#04b321', backgroundColor: '#04b321' },
  { id: 'booking', label: 'Scheduled', color: '#D700CC', backgroundColor: '#D700CC' },
]

// statusOptions.js
export const statusOptions = {
  // ─── TAKE-AWAY / POS ──────────────────────────────────────
  pos: {
    pending: ["accept", "reject"],          // Pending → Accept / Reject
    accept: ["preparing", "cancel"],       // Accepted → Start Preparing / Cancel
    preparing: ["pickup_ready"],              // Preparing → Ready to Pickup
    pickup_ready: ["completed"],                 // Pickup Ready → Complete
    completed: ["completed"],                            // no actions
  },

  // ─── DINE-IN ───────────────────────────────────────────────
  dine_in: {
    accept: ["preparing", "cancel"],       // sits “Accepted” until chef starts
    preparing: ["serving"],                   // Preparing → Ready to Serve
    serving: ["completed"],                 // →
    completed: ["completed"],                            // →
  },

  // ─── DELIVERY ──────────────────────────────────────────────
  delivery: {
    pending: ["accept", "reject"],          // Pending → Accept / Reject
    accept: ["preparing", "cancel"],       // →
    preparing: ["pickup_ready"],              // →
    pickup_ready: ["pickedup"],                  // Pickup Ready → Picked Up
    pickedup: ["out_for_delivery"],          // Picked Up → Out for Delivery
    out_for_delivery: ["delivered"],               // Out for Delivery → Delivered
    delivered: ["completed"],                 // Delivered → Complete
    completed: ["completed"],                            // →
  },

  // ─── SCHEDULED / BOOKING ───────────────────────────────────
  booking: {
    pending: ["accept", "reject"],          // Pending → Accept / Reject
    accept: ["ready_for_chef"],            // Accepted → Ready for Chef / Cancel
    ready_for_chef: ["preparing", "cancel"],       // Ready for Chef → Start Preparing
    preparing: ["serving"],                   // Preparing → Serving
    serving: ["completed"],                 // Serving → Complete
    completed: ["completed"],                            // →
  },

  // ─── PHONE ORDERL ─────────────────────────────────────────────
  phone_order: {
    pending: ["accept", "reject"],
    accept: ["preparing", "cancel"],
    preparing: ["pickup_ready"],
    pickup_ready: ["pickedup"],
    pickedup: ["out_for_delivery"],
    out_for_delivery: ["delivered"],
    delivered: ["completed"],
    completed: ["completed"],
  },

  // ─── COLLECTION POINT ──────────────────────────────────────
  collection_point: {
    pending: ["accept", "reject"],          // Pending → Accept / Reject
    accept: ["preparing", "cancel"],       // Accepted → Start Preparing / Cancel
    preparing: ["pickup_ready"],              // Preparing → Ready to Pickup
    pickup_ready: ["completed"],                 // Pickup Ready → Complete
    completed: ["completed"],                            // no actions
  },
};

// statusConfigs.js
export const statusConfigs = {
  pending: { text: "#794C8F", bg: "#D9D9D9", label: "Pending", optionLabel: "Pending" },
  accept: { text: "#047857", bg: "#6CFF66", label: "Accepted", optionLabel: "Accept" },
  preparing: { text: "#000", bg: "#86FFF1", label: "Preparing", optionLabel: "Start Preparing" },
  pickup_ready: { text: "#000", bg: "#FCD29B", label: "Pickup Ready", optionLabel: "Ready to Pickup" },
  completed: { text: "#064E3B", bg: "#00DD4C", label: "Completed", optionLabel: "Complete" },
  cancel: { text: "#7F1D1D", bg: "#FCB0AF", label: "Cancelled", optionLabel: "Cancel" },
  reject: { text: "#7F1D1D", bg: "#FCB0AF", label: "Rejected", optionLabel: "Reject" },
  serving: { text: "#92400E", bg: "#FCD29B", label: "Serving", optionLabel: "Ready to  Serve" },
  out_for_delivery: { text: "#000", bg: "#FCD29B", label: "Out for Delivery", optionLabel: "Out for Delivery" },
  pickedup: { text: "#000", bg: "#FCD29B", label: "Picked Up", optionLabel: "Picked Up" },
  delivered: { text: "#000", bg: "#00DD4C", label: "Delivered", optionLabel: "Delivered" },
  ready_for_chef: { text: "#000", bg: "#6CFF66", label: "Ready for Chef", optionLabel: "Ready to Chef" },
};

export const currencySymbol = (currency) => {
  if (currency == "EURO") {
    return "€"
  }
  if (currency == "USD") {
    return "$"
  }
  if (currency == "GBP") {
    return "£"
  }
}

export const servePanelStatusList = [
  { key: 'ready_to_prepare', label: 'Ready to Prepare', color: '#6CFF66', textColor: '#266029' },
  { key: 'preparing', label: 'Preparing', color: '#86FFF1', textColor: '#0E7165' },
  { key: 'ready_to_serve', label: 'Ready to Serve', color: '#FCD29B', textColor: '#8F580F' },
  { key: 'served', label: 'Served', color: '#FCD29B', textColor: '#8F580F' },
  // { key: 'completed',           label: 'Completed',           color: '#00DD4C', textColor:'#064E3B' },
];

export const validTransitions = {
  ready_to_prepare: ['preparing'],
  preparing: ['ready_to_prepare', 'ready_to_serve'],
  ready_to_serve: ['served'],
  served: [],
};


export const TABLE_STATUSES = {
  AVAILABLE: 'available',
  RESERVED: 'reserved',
  OCCUPIED: 'occupied',
  BLOCKED: 'blocked',
  SCHEDULED: 'scheduled',
};

export const getInfoText = (confirmAction, selectedTable) => {
  switch (confirmAction) {
    case 'block':
      return `Are you sure you want to block ${selectedTable?.table_no}?`;
    case 'unblock':
      return `Are you sure you want to unblock ${selectedTable?.table_no}?`;
    case 'split':
      return `Are you sure you want to split ${selectedTable?.table_no}?`;
    case 'release':
      if (!selectedTable?.reservation?.manual_release) {
        const formattedTime = new Date(
          selectedTable?.reservation?.reserved_till
        ).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
        return `This table is set to automatic release. It will be released at ${formattedTime}. Do you still want to release it now?`;
      }
      return `Are you sure you want to release ${selectedTable?.table_no}?`;
    case 'delete':
      return `Are you sure you want to delete ${selectedTable?.table_no}?`;
    default:
      return '';
  }
};

export const getBtnText = (confirmAction) => {
  switch (confirmAction) {
    case 'block':
      return 'Block';
    case 'unblock':
      return 'Unblock';
    case 'split':
      return 'Split';
    case 'release':
      return 'Release Now';
    case 'delete':
      return 'Delete';
    default:
      return '';
  }
};

// ----------------------------
//  Tables Screen Options
// ---------------------------
export const fromOptions = [
  { label: 'Now', value: 'now' },
  { label: 'Custom', value: 'custom' },
];

export const untilOptions = [
  { label: 'Manual Release', value: 'manual' },
  { label: '10 Minutes', value: '10' },
  { label: '15 Minutes', value: '15' },
  { label: '20 Minutes', value: '20' },
  { label: '25 Minutes', value: '25' },
  { label: '30 Minutes', value: '30' },
  { label: '40 Minutes', value: '40' },
  { label: '50 Minutes', value: '50' },
  { label: '1 Hour', value: '60' },
  { label: '2 Hours', value: '120' },
];

export const currencyOptions = [
  { value: 'EURO', label: 'EURO' },
  { value: 'USD', label: 'USD' },
  { value: 'GBP', label: 'GBP' },
];

export const paymentMethodOptions = [
  { label: "Cash", value: "cash" },
  { label: "Credit/Debit Card", value: "card" },
  // { label: "Mobile Wallet", value: "mobilewallet" },
  // { label: "Gift Card/Voucher", value: "gift_card_voucher" },
  // { label: "Loyalty Points", value: "loyalty_points" },
]